import React from 'react' 
import { Redirect, Link } from 'react-router-dom'
import { getRecentTexts } from '../actions/text'
import { connect } from 'react-redux'
import './explore-page.css'

import Spinner from './spinner'

export class ExplorePage extends React.Component {
	constructor(props) {
		super(props)
		this.descriptionRefs = []
		this.arrowRefs = []
	}

	componentDidMount() {
		this.props.dispatch(getRecentTexts())
	}

	showDescription(i, e) {
		e.preventDefault()
		this.descriptionRefs[i].classList.toggle('hide')
		this.arrowRefs[i].classList.toggle('rotate')
	}

	render() {
		if(!this.props.loggedIn) {
			return <Redirect to='/' />
		}

		const spin = !this.props.recentTexts.length ? <Spinner /> : <div></div>

		const texts = this.props.recentTexts.length ? this.props.recentTexts.map((text, i) => {
			const arrow = text.description ? <div 
						className='arrow' 
						onClick={ e => this.showDescription(i, e) } 
						ref={ input => this.arrowRefs[i] = input }
					>▶</div> : <div></div>

			return <div className='table-row col-12' key={ i }>
				<div className='explore-title col-6'>
					<Link className='title-link' to={{
							pathname: `/text/${ text.title }`,
							state: { textId: text._id }
						}}>{ text.title }
					</Link>
					{arrow}
				</div>
				<Link className='col-6' to={{
					pathname: `/user/${ text.authorId}`,
					state: { userId: text.authorId }
				}}><div className='author-name'>{ text.authorName }</div></Link>
				<div 
					ref={ input => this.descriptionRefs[i] = input } 
					className='view-description col-6 hide'>
					{ text.description }
				</div>
			</div>
		})
		: <div></div>

		return (
			<div className='row'>
				<h2 className='explore-header'>New Papers</h2>
				<div className='col-8 explore-table'>
					{texts}
				</div>
				{ spin }
			</div>
		)
	}
}

const MapStateToProps = state => ({
	loggedIn: state.auth.currentUser !== null,
	recentTexts: state.text.recentTexts
})

export default connect(MapStateToProps)(ExplorePage)


// WEBPACK FOOTER //
// ./src/components/explore-page.js